export default __webpack_public_path__ + "df2393b4ae7511908f938d8e41c27487.svg";